import Loadable from 'react-loadable';

export const IconPicker = Loadable({
  loader: () => import('./picker'),
  loading: () => null,
  render(loaded, props) {
    const { IconPicker: IconPickerComponent } = loaded;
    return <IconPickerComponent {...props} />;
  },
});
